import React from "react";
import { Link } from "react-router-dom";
import HeroImg from "../Assets/img/hero-img.png";
const Hero = ({ schoolInfo }) => {
  return (
    <>
      <section className="eschool-hero">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6  col-12">
              <div className="eschool-hero-content">
                <h1 className="eschool-hero-cont-title">
                  <span className="eschool-hero-sm-title">Welcome to</span>
                  <br />
                  {schoolInfo?.school_Name}
                </h1>
                <p className="eschool-hero-cont-text">
                  {schoolInfo?.sort_detail}
                </p>
                <div className="eschool-hero-cont-btn">
                  <Link to="/aboutus" className="eschool-btn">
                    About us
                  </Link>
                  <Link
                    to="/applyadmission"
                    className="eschool-btn secondary-btn"
                  >
                    Free registration
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-12">
              <div className="eschool-hero-img">
                <img src={HeroImg} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
